module.exports = __webpack_public_path__ + "static/img/white-curved.4dc196db.jpeg";